import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { AgreementCreateDateFormViewProps } from "models/propTypes/agreementPropTypes";
import { DateInputProps, NumberInputProps } from "models/propTypes/wintFormPropsTypes";
import { differenceInMonths } from "date-fns";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DateInput, NumberInput, VerticalFormField } from "components/common/wintForms";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const AgreementDateSection: React.FC<AgreementCreateDateFormViewProps> = (props) => {
  const { connect, values, nonEditable } = props;

  const noticeMonthsProps = connect("noticeMonths");
  const endDateProps = connect("end");
  const endsLastProps = connect("endsLast");

  const onNoticeMonthsChange = (e: React.ChangeEvent<any>) => {
    const updatedValue = e.target.value;
    noticeMonthsProps.setValue(updatedValue);

    if (values.end !== undefined && updatedValue !== 0) {
      const noticeDate = DateHelper.addMonths(values.end, -(updatedValue ?? 0));
      endsLastProps.setValue(noticeDate);
    }
  };

  const onEndDateSetValue = (value: Date) => {
    endDateProps.setValue(value);
    const noticeDate = DateHelper.addMonths(new Date(value), -(values.noticeMonths ?? 0));
    endsLastProps.setValue(noticeDate);
  };

  const onEndsLastDateSetValue = (value: number | Date) => {
    endsLastProps.setValue(value);
    setNoticeMonthsOnEndsLastDate(value);
  };

  const setNoticeMonthsOnEndsLastDate = (updatedValue: number | Date) => {
    let noticeMonths: number;
    if (values.end !== undefined) {
      noticeMonths = Math.abs(differenceInMonths(values.end, updatedValue));
      if (noticeMonths === 0 && values.noticeMonths === undefined) {
        return;
      } else if (noticeMonths === 0 && values.noticeMonths !== undefined) {
        noticeMonthsProps.setValue(0);
      } else if (noticeMonths === values.noticeMonths) {
        return;
      } else if (noticeMonths > 0) {
        noticeMonthsProps.setValue(noticeMonths);
      }
    }
  };

  return (
    <>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={6}>
          <VerticalFormField<DateInputProps>
            Component={DateInput}
            {...connect("start")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StartDate)}
            optional
            disabled={nonEditable}
          />
        </Grid>
        <Grid item xs={6}>
          <VerticalFormField<DateInputProps>
            Component={DateInput}
            {...endDateProps}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EndDate)}
            optional
            disabled={nonEditable}
            setValue={onEndDateSetValue}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={6}>
          <VerticalFormField<DateInputProps>
            Component={DateInput}
            {...endsLastProps}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Agreement.EndsLast)}
            icon={IconDefinitionConstants.WValidateCheck}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Agreement.EndsLastHelpText)}
            optional
            disabled={nonEditable}
            setValue={onEndsLastDateSetValue}
          />
        </Grid>
        <Grid item xs={6}>
          <VerticalFormField<NumberInputProps>
            Component={NumberInput}
            {...noticeMonthsProps}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Agreement.NoticePeriod)}
            onChange={onNoticeMonthsChange}
            optional
            disabled={nonEditable}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AgreementDateSection;
